(function() {
    'use strict';
    angular
        .module('uniromaLandingApp')
        .factory('Provider_tr', Provider_tr);

    Provider_tr.$inject = ['$resource'];

    function Provider_tr ($resource) {
        var resourceUrl =  'api/provider-trs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
